// import React from 'react';

// const Loader = () => (
//   <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-white">
//     <div className="loader-spinner" />
//   </div>
// );

// export default Loader; 


import React from 'react';

const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white">
      {/* Optional: Company Logo */}
      <img
        src="/images/logo.webp" // change to your actual logo path
        alt="MEP Consultant Logo"
        className="w-24 h-24 mb-4 animate-pulse"
      />

      {/* Spinner */}
      <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mb-4"></div>

      {/* Loading Text */}
      <p className="text-lg text-gray-600 font-medium tracking-wide">
        Loading MEP Consultant Portal...
      </p>
    </div>
  );
};

export default Loader;
